let prefix = "/appointments"

export default {
    fetchAppointments: () => axios.get(`${prefix}/recent`),
    fetchAppointment: (id) => axios.get(`${prefix}/${id}`),
}
